import { PropsWithChildren } from 'react';

export default function NotificationBadge({children}: PropsWithChildren) {
    return (
        <div
            className="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-alfa1-brand-primary-500 border-2 border-white rounded-full -top-2 -end-2 dark:border-gray-900">{children}
        </div>
    )
}